export interface SharedState {
    loading: {
        global: number;
        [key: string]: number;
    };
    popup: {
        isVisible: boolean;
    };
}

export const initialSharedState: SharedState = {
    loading: {
        global: 0,
    },
    popup: {
        isVisible: false,
    },
};
